import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { combineReducers } from 'redux';
import applicationDetailsReducer from './applicationDetailsReducer';
import applicationLandingReducer from './applicationLandingReducer';
import creditLineReducer from './creditLineReducer';
import documentReducer from './documentReducer';
import applicationDocumentsReducer from './applicationDocumentsReducer';
import errorReducer from './errorReducer';
import existingPaymentMethodsReducer from './existingPaymentMethodsReducer';
import plasticAddressReducer from './plasticAddressReducer';
import identificationReducer from './identificationReducer';
import initialDetailsReducer from './initialDetailsReducer';
import loaderReducer from './loaderReducer';
import welcomerPopupReducer from './welcomerPopupReducer';
import verificationReducer from './verificationReducer';

const reducers = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    loader: loaderReducer,
    error: errorReducer,
    applicationLanding: applicationLandingReducer,
    initialDetails: initialDetailsReducer,
    identification: identificationReducer,
    applicationDetails: applicationDetailsReducer,
    existingPaymentMethods: existingPaymentMethodsReducer,
    plasticAddress: plasticAddressReducer,
    creditLine: creditLineReducer,
    document: documentReducer,
    applicationDocuments: applicationDocumentsReducer,
    welcomerPopup: welcomerPopupReducer,
    verification: verificationReducer,
  });

export default reducers;
export type StateType = ReturnType<ReturnType<typeof reducers>>;
